import { Override } from "../../../../../graphql/types"
import { Maybe } from "@figurepos/fgr-lib-business-logic/lib/common/types"

export type ItemOverrideV2 = Omit<Override, "data" | "context"> & {
    context: OverrideContext
    data: ItemOverrideData
}

export type ItemOverrideData = {
    price?: Maybe<number>
    optionGroup?: ItemOverrideOptionGroup
}

export type ItemOverrideOptionGroup = {
    id: string
    isActive: boolean
    options: ItemOverrideOption[]
}

export type ItemOverrideOption = {
    id: string
    price: number | undefined
}

export enum OverrideContext {
    Terminal = "terminal",
    Location = "location",
}
